import { all, takeEvery, put, fork, call } from "redux-saga/effects";

import actions from "@iso/redux/taskStatus/actions";
import {taskStatusService} from "@iso/services";


function* fetchAllStatus() {
  yield takeEvery(actions.GET_STATUS_REQUEST, function* () {
    try {
      const statuses = yield call(taskStatusService.fetchAllTaskStatus);

      yield put({
        type: actions.GET_STATUS_SUCCESS,
        statuses: statuses?.rows || [],
      });
    } catch (error) {
        yield put({type: actions.GET_STATUS_ERROR});
    }
  });
}

function* fetchStatusesByScreen() {
  yield takeEvery(actions.GET_STATUS_BY_SCREEN_REQUEST, function* ({ payload }) {
    const { screen } = payload;
    try {
      const response = yield call(taskStatusService.getTaskStatusesByScreen, { screen });
      yield put({
        type: actions.GET_STATUS_BY_SCREEN_SUCCESS,
        statuses: response?.rows || [],
      });
    } catch (error) {
      yield put({
        type: actions.GET_STATUS_BY_SCREEN_ERROR,
        error: error.response,
      });
    }
  });
}

export default function* rootSaga() {
    yield all([
        fork(fetchAllStatus),
        fork(fetchStatusesByScreen),
    ]);
}
